<style>
  :host {
    display: flex;
    width: 100%;
  }
</style>
<ng-container *transloco="let t; read: 'ime.common.classificators'">
  <ng-container *ngLet="allItems$ | async | orderBy: ['Sequence', 'Code'] as allItems">
    <ng-select #select class="select-sm form-control {{dropDownCssClass}}" *ngLet="(classificatorsQuery.selectEntity(classificatorId ?? allItems[0]?.ClassificatorId) | async) as classificator"
               [class.is-invalid]="isInvalid"
               [class.readOnly]="readonly"
               [name]="name"
               [items]="allItems"
               [searchFn]="searchFn"
               [readonly]="readonly"
               [multiple]="multiple"
               [virtualScroll]="classificator?.TypeClv !== Classificators.ClassificatorType.Image"
               [placeholder]="placeholder"
               [clearable]="clearable"
               [ngModel]="multiple ? entityIds : entityId" (ngModelChange)="multiple ? entityIds : entityId = $event"
               (open)="readonly ? select.close() : select.open()"
               (change)="onSelectionChanged($event)"
               appendTo="body"
               bindLabel="DisplayName"
               bindValue="Id">
      <ng-container *ngIf="classificator?.TypeClv === Classificators.ClassificatorType.Image">
        <ng-template ng-label-tmp let-item="item">
          <div class="d-flex mb-0">
            <ng-container [ngTemplateOutlet]="imgTemplate" [ngTemplateOutletContext]="{item: item}"></ng-container>
          </div>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <ng-container [ngTemplateOutlet]="imgTemplate" [ngTemplateOutletContext]="{item: item}"></ng-container>
        </ng-template>
        <ng-template #imgTemplate let-item="item">
          <div class="d-flex mb-0">
            <h6 class="my-auto me-1" [class.col-1]="item.Data">{{item.Code}}
              <ng-container *ngIf="item.Data">:</ng-container>
            </h6>
            <ng-container *ngIf="item.Data">
              <img *ngLet="item.Data | jsonParse as imageData" class="mw-100 h-auto ms-1" [src]="imageData.Path | assetImageUrl" [alt]="item.Value" [style.max-height]="(imageData.MaxHeight ?? 256) + 'px'"/>
            </ng-container>
          </div>
        </ng-template>
      </ng-container>
      <ng-template ng-option-tmp let-item="item" *ngIf="classificator?.TypeClv !== Classificators.ClassificatorType.Image" let-searchTerm="searchTerm">
        <span [ngOptionHighlight]="searchTerm" [title]="item.DisplayName ?? ''">
          {{item.DisplayName}}
        </span>
      </ng-template>
      <ng-template ng-footer-tmp>
        <ng-container *ngIf="entityId && allowEdit">
          <button type="button" *ngIf="allItems$ | async | find: ['Id']: entityId as item" class="btn btn-sm btn-outline-primary me-1" (click)="select.close(); editExisting(item)">
            <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
          </button>
        </ng-container>
        <button type="button" *ngIf="allowAdd" class="btn btn-sm btn-outline-primary me-1" (click)="select.close(); addNewClassificatorValue()">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
        </button>
      </ng-template>
      <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
        <div class="ng-option disabled">
          <button type="button" *ngIf="allowAdd" class="btn btn-sm btn-outline-primary me-1" (click)="select.close(); addNewClassificatorValue(searchTerm)">
            <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
            {{t('Add')}} "{{searchTerm}}"
          </button>
          <span *ngIf="!allowAdd">{{t('No item named')}} "{{searchTerm}}"</span>
        </div>
      </ng-template>
    </ng-select>
  </ng-container>
</ng-container>
